import titleCase from "./titleCase";

export default function normalizeStateName(s) {
  if (!s) return "";
  const x = String(s).trim().toLowerCase();
  const map = {
    rajstan: "Rajasthan",
    rajasthan: "Rajasthan",
    maharastra: "Maharashtra",
    maharashtra: "Maharashtra",
    "madhya pradesh": "Madhya Pradesh",
    mp: "Madhya Pradesh",
    orrisa: "Odisha",
  };
  return map[x] || titleCase(String(s).trim());
}